// extracted by mini-css-extract-plugin
export default {"field":"FormSelectInput_field__c++DM","label":"FormSelectInput_label__Iq1L8","select":"FormSelectInput_select__EZvRe","error":"FormSelectInput_error__CZVYZ"};